import { USER_ROLE } from 'models/User'
import ROUTES from 'routing/adminRoutes'
import { AsyncAmOverview } from 'ui/pages'
import AdminRouteLayout from '../../../Admin/AdminRouteLayout'
import AdminRoute from '../../AdminRoute'

const amOverviewRoutes = [
  <AdminRoute
    exact
    path={ROUTES.AM_OVERVIEW}
    layout={AdminRouteLayout}
    component={AsyncAmOverview}
    allowedRoles={[
      USER_ROLE.ACCOUNT_MANAGER_LEVEL_1,
      USER_ROLE.ACCOUNT_MANAGER_LEVEL_2,
      USER_ROLE.ADMIN,
    ]}
    redirectTo={ROUTES.SHIFTS}
    key={ROUTES.AM_OVERVIEW}
  />,
]

export default amOverviewRoutes
